import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { trackFormSubmission } from "../lib/analytics";

export const JotformEmbed = ({
  formId = "261773727058062",
  testId = "jotform-embed",
}) => {
  const containerId = `jotform-${formId}`;
  const navigate = useNavigate();

  useEffect(() => {
    const container = document.getElementById(containerId);
    if (!container || container.dataset.loaded === "true") return;

    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src = `https://form.jotform.com/jsform/${formId}`;
    script.async = true;
    container.appendChild(script);
    container.dataset.loaded = "true";

    const handleMessage = (e) => {
      try {
        const data = typeof e.data === "string" ? JSON.parse(e.data) : e.data;
        if (data && data.action === "submission-completed") {
          trackFormSubmission("jotform_quote");
          navigate("/request-received");
        }
      } catch {
        // ignore non-JSON messages
      }
    };
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, [containerId, formId, navigate]);

  return (
    <div
      id={containerId}
      className="w-full min-h-[500px]"
      data-testid={testId}
    />
  );
};
